import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import toast from 'react-hot-toast'
import { InputText } from 'primereact/inputtext'

import { fetchData } from '../../helpers/fetchData'
import { setSelectedPatient } from '../../redux/slices/AuthSlice'

function PatientSearchFeild() {
    const navigate = useNavigate()
    const { t, i18n } = useTranslation()
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const auth = useSelector(state => state.auth)
    const [filterText, setFilterText] = useState('')
    const [selected, setSelected] = useState('file_no')

    const searchOptions = [
        {
            label: t('File No'),
            value: 'file_no',
            key: 'file_no',
            errorMsg: 'Enter a file number to search.'
        },
        {
            label: t('Document Id'),
            value: 'doc_id',
            key: 'document_id',
            errorMsg: 'Enter Document Id to search.'
        }
    ]

    const handleSearch = async () => {
        const option = searchOptions.find(opt => opt.value === selected)
        if (!filterText.trim()) {
            toast.error(option.errorMsg)
            return
        }

        setLoading(true)
        try {
            const url = '/patient/filter'
            const res = await fetchData('POST', url, {
                [option.key]: filterText.trim(),
                ...(option.value === 'mob_no' ? {} : {})
            })
            const resData = res?.data || []
            if (resData?.length === 1) {
                dispatch(setSelectedPatient({
                    labData: res?.data?.[0],
                    searchParams: { [option.key]: filterText.trim() }
                }))
                const targetPath = "/his/patient-profile/allergies"
                navigate(targetPath, {
                    state: {
                        labData: res?.data?.[0],
                        searchParams: { [option.key]: filterText.trim() }
                    }
                })
            }
            else if (resData?.length > 1) {
                dispatch(setSelectedPatient({
                    labData: res?.data?.[0],
                    searchParams: { [option.key]: filterText.trim() }
                }))
                const targetPath = "/his/patient-profile/allergies"
                navigate(targetPath, {
                    state: {
                        labData: res?.data?.[0],
                        searchParams: { [option.key]: filterText.trim() }
                    }
                })
            }
        } catch (err) {
            console.error(err)
        } finally {
            setLoading(false)
        }
    }

    const isActive = val => val === selected

    return (
        <div className='w-full hidden md:flex items-center justify-end'>
            <InputText
                style={{
                    borderRadius: '0px',
                    border: 'none',
                    backgroundColor: 'white'
                }}
                disabled={loading}
                value={filterText}
                onChange={e => setFilterText(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && handleSearch()}
                placeholder={`${t('Search with')}${t(
                    selected === 'file_no'
                        ? 'File Number'
                        : selected === 'doc_id'
                            ? 'Document ID'
                            : 'Mobile No'
                )}`}
                className={`h-[30px] ${i18n.language == 'en' ? '!rounded-l-md' : '!rounded-r-md'
                    } border-r-0 focus:ring-0 !bg-gray-200 focus:border-blue-500 w-full max-w-[250px]`}
            />

            <div className='flex items-center shrink-0'>
                {searchOptions.map((option, index) => (
                    <button
                        key={option.value}
                        className={`px-2 py-2 text-sm font-medium h-[30px] min-w-[80px] transition-all duration-200 ${i18n.language == 'en' ? 'border-l' : 'border-r'
                            } ${index === searchOptions.length - 1
                                ? i18n.language == 'en'
                                    ? 'rounded-r-md'
                                    : 'rounded-l-md'
                                : null
                            } border-gray-300 ${isActive(option.value)
                                ? 'bg-primary text-white'
                                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                            }`}
                        onClick={() => setSelected(option.value)}
                    >
                        {option.label}
                    </button>
                ))}
            </div>
        </div>
    )
}

export default PatientSearchFeild
